import { Box, chakra, Checkbox, HStack, Text } from '@chakra-ui/react';
import { useCheckoutConfigContext } from '@contexts/CheckoutConfig';
import { FormValues } from '@types';
import { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { When } from 'react-if';

const PrivacyItem: FC<{ code: string; error: boolean }> = ({ code, error }) => {
  const { t } = useTranslation();
  const { checkout } = useCheckoutConfigContext();
  const { control } = useFormContext<FormValues>();

  const privacyDefinition = checkout.campaign.privacy_fields.find((f) => f.code === code);
  if (!privacyDefinition) {
    throw new Error(`Privacy field with code ${code} not found`);
  }

  return (
    <Box>
      <Controller
        control={control}
        name="acceptedPrivacyFields"
        render={({ field }) => {
          return (
            <HStack spacing={2} alignItems="start">
              <Checkbox
                isRequired={privacyDefinition.is_required}
                mt={0.5}
                isChecked={field.value.includes(code)}
                onChange={(e) => {
                  if (e.target.checked) {
                    field.onChange([...field.value, code]);
                  } else {
                    field.onChange(field.value.filter((c) => c !== code));
                  }
                }}
              />
              <Text fontSize="sm" color="blackAlpha.800">
                <chakra.span fontSize="sm" color="blackAlpha.800">
                  {privacyDefinition.message}
                </chakra.span>

                <When condition={!!privacyDefinition.is_required}>
                  <chakra.span fontSize="sm" color="red.500">
                    {' '}
                    *
                  </chakra.span>
                </When>

                <chakra.span display="block" fontSize="sm" color="red.500">
                  {error && t('You must agree to our terms in order to proceed')}
                </chakra.span>
              </Text>
            </HStack>
          );
        }}
      />
    </Box>
  );
};

export default PrivacyItem;
